var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.$route.path,"background-color":"#232c3b","text-color":"#A0ACB9","active-text-color":"#fff","router":"","unique-opened":""}},[_c('MenuItem',{attrs:{"routes":_vm.routes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }